import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ComponentContext,
  ConfirmationOptions,
  confirmDefaults,
  defaultModalOptions,
  NotificationInfo,
  Options
} from './modal.model';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { NotificationDetailsComponent } from './notification-details-modal/notification-details.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private bsModalService: BsModalService) {}

  public openModal<T, N = void>(
    component: Type<ComponentContext<T, N>>,
    options?: Options<T>,
    autoClose?: true
  ): Observable<N>;
  public openModal<T, N = void>(
    component: Type<ComponentContext<T, N>>,
    options?: Options<T>,
    autoClose?: false
  ): Observable<[N, BsModalRef]>;
  public openModal<T, N = void>(component: any, options: any = {}, autoClose = true): any {
    const { componentData, modalOptions } = options;
    const modalRef = this.bsModalService.show<any>(component, {
      ...defaultModalOptions,
      ...modalOptions,
      initialState: componentData
    });

    return new Observable(observer => {
      modalRef.content.onAction = (value: N) => {
        if (autoClose) {
          modalRef.hide();
          observer.next(value);
          observer.complete();
        } else {
          observer.next([value, modalRef]);
        }
      };
      modalRef.content.onClose = () => {
        modalRef.hide();
        observer.complete();
      };
    });
  }

  public confirm$(options: Partial<ConfirmationOptions> = {}): Observable<void> {
    return this.openModal<ConfirmationOptions>(ConfirmModalComponent, {
      componentData: { ...confirmDefaults, ...options }
    });
  }

  public showNotificationInfo$(options: NotificationInfo): Observable<void> {
    return this.openModal<NotificationInfo>(NotificationDetailsComponent, {
      componentData: options,
      modalOptions: { class: '' }
    });
  }
}
